// Import model
import { Match } from '../models/Match';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for Match - handles JSON serialization and deserialization with type validation
 */
export class MatchSerializer {
  /**
   * Deserializes a JSON string into a Match instance
   */
  static deserialize(json: string): Match {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a Match instance
   */
  static fromObject(obj: any): Match {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to Match');
    }


    const instance: Match = {
      type_: obj['type'] as string | undefined,
      value: obj['value'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of Match instances
   */
  static deserializeArray(json: string): Match[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a Match instance to a JSON string
   */
  static serialize(instance: Match): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a Match instance to a plain object
   */
  static toObject(instance: Match): any {
    return {
      'type': instance.type_,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of Match instances to a JSON string
   */
  static serializeArray(instances: Match[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
